<!-- 专题题库 -->
<template>
<div class="m-special-topic-home">
    <div class="nav-box" v-show="$route.name !== 'MSpecialTopicBuyResult'">
        <div class="examname-handle" @click="handleOpenChangeExam">
            <div class="examname">{{ examinfo.shortname }}</div>
            <img class="handle-icon" v-if="$route.name === 'MSpecialTopic' || $route.name === 'MSpecialChoose'" :src="require('@/common/images/specialTopic/change_icon.png')" title="切换" />
        </div>
        <div class="menu-box">
            <div class="menu-item" :class="{active: $route.name === 'MSpecialTopic'}" @click="handleJump('MSpecialTopic')">题库</div>
            <div class="menu-item" :class="{active: $route.name === 'MSpecialChoose'}" @click="handleJump('MSpecialChoose')">选购</div>
            <div class="menu-item">小程序</div>
            <img @click="handleClickHead" class="head-picture" :src="user.isLogin ? user.logourl : require('@/common/images/header/user_icon.png')" />
        </div>
    </div>
    <el-scrollbar class="special-topic-home-scroll">
        <router-view></router-view>
    </el-scrollbar>
    <div class="loading" v-show="loading">
        <van-loading vertical type="spinner" color="#1989fa"><span style="font-size: 0.24rem">加载中...</span>
        </van-loading>
    </div>
    <ChangeExam ref="changeExam"></ChangeExam>
    <LoginHandle ref="loginHandle" @handleOpenList="handleOpenList"></LoginHandle>
    <Wdct ref="wdct" :subjectList="subjectList"></Wdct>
    <Wdsc ref="wdsc" :subjectList="subjectList"></Wdsc>
    <Lxjl ref="lxjl" :subjectList="subjectList"></Lxjl>
</div>
</template>

<script>
import specialTopic from '@/common/js/specialTopic.json'
import {mapGetters, mapActions} from 'vuex'
import ChangeExam from './page/component/changeExam.vue'
import LoginHandle from './page/component/loginHandle.vue'
import Wdct from './page/topicComponent/wdct.vue'
import Wdsc from './page/topicComponent/wdsc.vue'
import Lxjl from './page/topicComponent/lxjl.vue'
export default {
    data() {
        return {
            examinfo: {
                examcode: 'jjcy',
                examname: '基金从业题库',
                shortname: '基金从业'
            },
            loginHandlePopup: false,
            subjectList: []
        }
    },
    components: {
        ChangeExam,
        LoginHandle,
        Wdct,
        Wdsc,
        Lxjl
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.subjectList = JSON.parse(JSON.stringify(specialTopic.subject[this.examinfo.examcode]))
        this.setClientType(2)
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpenChangeExam() {
            this.$refs.changeExam.handleOpen()
        },
        handleJump(name) {
            if (name === 'MSpecialTopic') {
                this.$router.push({
                    name,
                    params: {
                        examcode: this.examinfo.examcode ? this.examinfo.examcode : 'jjcy'
                    }
                })
            } else {
                this.$router.push({
                    name,
                    params: {
                        examcode: this.examinfo.examcode ? this.examinfo.examcode : 'jjcy'
                    }
                })
            }
        },
        handleClickHead() {
            if (!this.user.isLogin) {
                this.$router.push({
                    name: 'MLogin'
                })
            } else {
                this.$refs.loginHandle.handleOpen()
            }
        },
        handleOpenList(name) {
            this.$refs[name].handleOpen()
        },
        ...mapActions([
            'setClientType'
        ])
    },
    computed: {
        ...mapGetters(['loading', 'user'])
    },
    watch: {
        '$route.query': {
            handler(newV) {
                if (newV.examcode || this.$route.params.examcode) {
                    let index = ''
                    specialTopic.exam.some((item, i) => {
                        if (item.examcode === this.$route.params.examcode || item.examcode === this.$route.query.examcode) {
                            index = i
                            return true
                        }
                    })
                    this.examinfo = JSON.parse(JSON.stringify(specialTopic.exam[index]))
                } else {
                    this.examinfo = {
                        examcode: 'jjcy',
                        examname: '基金从业题库',
                        shortname: '基金从业'
                    }
                }
            },
            deep: true,
            immediate: true
        },
        '$route.params': {
            handler(newV) {
                if (newV.examcode || this.$route.query.examcode) {
                    let index = ''
                    specialTopic.exam.some((item, i) => {
                        if (item.examcode === this.$route.params.examcode || item.examcode === this.$route.query.examcode) {
                            index = i
                            return true
                        }
                    })
                    this.examinfo = JSON.parse(JSON.stringify(specialTopic.exam[index]))
                } else {
                    this.examinfo = {
                        examcode: 'jjcy',
                        examname: '基金从业题库',
                        shortname: '基金从业'
                    }
                }
            },
            deep: true,
            immediate: true
        },
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
@import "~common/scss/index";
.m-special-topic-home {
    background: #F8F8F8;
    .nav-box {
        height: 0.88rem;
        background: #fff;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .examname-handle {
            display: flex;
            align-items: center;
            .examname {
                font-size: 0.32rem;
                color: #333333;
                font-weight: bold;
            }
            .handle-icon {
                width: 0.28rem;
                height: 0.28rem;
                margin-left: 0.2rem;
            }
        }
        .menu-box {
            display: flex;
            align-items: center;
            .menu-item {
                font-size: 0.32rem;
                color: #333333;
                margin-right: 0.32rem;
                &.active {
                    color: #1D60AD;
                    font-weight: bold;
                }
            }
            .head-picture {
                width: 0.5rem;
                height: 0.5rem;
                border-radius: 50%;
            }
        }
    }
    .special-topic-home-scroll {
        height: calc(100vh - 0.88rem);
    }
    .loading {
        @include flexBox(center);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .2);
        z-index: 10000;
    }
}
</style>